import { DraftInlineStyleType, RawDraftContentBlock } from 'draft-js';
import { SEPARATE_NEXT, SEPARATE_NEXT_PHRASE } from '../../constants/textEditor';
import { ExemplarWord } from '../../types';
import { HIGHLIGHT, PHRASES, PREPOSITIONAL_PHRASES, TEXT_TYPE, LANGUAGE } from './../../constants/index';

export const isHighlighted = (word: ExemplarWord): boolean => {
  return 'highlight' in word;
};

export const handleHighlight = (word: ExemplarWord, editorBlock: RawDraftContentBlock, styleOffset: 0 | 1): void => {
  let subWordOffset = styleOffset;
  word.text.split(' ').map(subWord => {
    editorBlock.inlineStyleRanges.push({
      offset: editorBlock.text.length + subWordOffset,
      length: subWord.length,
      style: JSON.stringify({ text: subWord, flag: HIGHLIGHT, value: word.highlight }) as DraftInlineStyleType,
    });
    subWordOffset += subWord.length + 1;
  });
};

export const handleFlaggedWords = (
  flaggedWords: string[],
  newWord: ExemplarWord,
  word: string,
  defaultStyles: string[] = []
): void => {
  flaggedWords.length &&
    flaggedWords.map(flaggedWord => {
      try {
        const { text, flag, value } = JSON.parse(flaggedWord);

        if (text === word) {
          switch (flag) {
            case HIGHLIGHT:
              newWord.highlight = value;
              break;
            case PREPOSITIONAL_PHRASES:
              newWord.prepositional_phrase = true;
              break;
            case PHRASES:
              newWord.phrase = true;
              break;
            case SEPARATE_NEXT:
              defaultStyles.push(SEPARATE_NEXT);
              break;
            case SEPARATE_NEXT_PHRASE:
              defaultStyles.push(SEPARATE_NEXT_PHRASE);
              break;
            case TEXT_TYPE:
              newWord.text_type = value;
              break;
            case LANGUAGE:
              newWord.language = value;
              newWord.hasDefaultLanguage = true;
              break;
          }
        }
      } catch (e) {
        // eslint-disable-next-line no-empty
      }
    });
};
